<template>
  <div class="header" :class="{ 'header-absolute': absolute }">
    <!-- <img class="logo" src="../assets/logo.png" /> -->
    <div class="nav">
      <div
        class="link"
        :class="{ 'link-active': $route.path == link.path }"
        v-for="link in links"
        :key="link.path"
        @click="go(link.path)"
      >
        {{ link.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["absolute"],
  data() {
    return {
      links: [
        { path: "/", name: "通友.cn" },
        { path: "/about", name: "媒体发布" }
      ]
    };
  },
  methods: {
    go(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style lang="scss">
.header {
  position: relative;
  width: 100%;
  padding: 0.285rem 0;
  height: 0.24rem;
  line-height: 0.24rem;
  color: #fff;
  .logo {
    float: left;
    height: 0.24rem;
    width: 0.985rem;
    margin-left: 0.42rem;
  }
  .nav {
    float: left;
    margin-left: 2rem;
    .link {
      display: inline-block;
      vertical-align: middle;
      height: 0.24rem;
      line-height: 0.24rem;
      color: rgba(255, 255, 255, 0.8);
      text-decoration: none;
      transition: color 0.3s;
      font-size: 0.09rem;
      margin-left: 0.4rem;
      outline: none;
      cursor: pointer;
      &:hover {
        color: #fff;
      }
    }
    .link-active {
      color: #fff;
      border-bottom: 1px solid #fff;
    }
  }
}
.header-absolute {
  position: absolute;
  z-index: 1988;
  top: 0;
  left: 0;
  right: 0;
}
</style>
